import { usePreviousRoute } from '~/composables/previousRoute'

export default defineNuxtRouteMiddleware((to, from) => {
  const { setPreviousRoute } = usePreviousRoute()
  // console.log('Previous Route Middleware:', { to, from })
  const isRestartedSurvey = from.path === '/surveys/create' && to.path === '/surveys/create'
  const isRestartedProduct = from.path === '/products/create' && to.path === '/products/create'
  const isProductToSurvey = from.path === '/products/create' && to.path === '/surveys/create'
  const isSurveyToProduct = from.path === '/surveys/create' && to.path === '/products/create'
  const isRestartedProfile = from.path === '/profile' && to.path === '/profile'
  const isProfileToChangePassword = from.path === '/profile' && to.path === '/profile/change-password'
  const isChangePasswordToProfile = from.path === '/profile/change-password' && to.path === '/profile'
  const isConfirmOtp = to.path === '/confirm-otp' || to.path === '/confirm-otp/'

  // Only store plain route info to avoid circular structure
  const safeFrom = {
    path: from.path,
    fullPath: from.fullPath,
    name: from.name,
    params: from.params,
    query: from.query,
  }

  // If the previous route is not the same as the current one and is not the root path
  if (from.fullPath !== to.fullPath && from.fullPath !== '/') {
    // Set the previous route in the composable
    setPreviousRoute(safeFrom)
    localStorage.setItem('previousRoute', JSON.stringify(safeFrom))
  }

  // Remove product unless it's one of the exceptions
  if (
    !isRestartedSurvey &&
    !isRestartedProduct &&
    !isProductToSurvey &&
    !isSurveyToProduct
  ) {
    localStorage.removeItem('product')
    localStorage.removeItem('previousRoute')
    localStorage.removeItem('surveyDraft')
  }

  // If navigating between profile and change-password, do not clear previousRoute
  if(
    !isRestartedProfile &&
    !isProfileToChangePassword &&
    !isChangePasswordToProfile &&
    !isConfirmOtp
  ) 
  {
    localStorage.removeItem('confirm-otp') // Clear confirm-otp on other routes
  }
})

